import scoreAss from '@/api/score-assessment-main'
import scoreAssDetail from '@/api/score-assessment-detail-component'
import mainProgram from '@/api/main-program'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return scoreAss.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return scoreAss.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await scoreAss.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  update(context, { id, data }) {
    return scoreAss.update(id, data)
  },
  storeDetailComponent(context, data) {
    return scoreAssDetail.store(data)
  },
  findDetailComponent(context, { sc_setup_id, program_structure_id }) {
    return scoreAssDetail.find(sc_setup_id, {
      params: {
        program_structure_id: program_structure_id
      }
    })
  },
  getMainProgram(context, attributes) {
    return mainProgram.get({
      params: attributes,
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getProgramStructure(context, sc_setup_id) {
    return scoreAssDetail.getProgramStructure(sc_setup_id)
  },
  storeCustomDivider(context, data) {
    return scoreAssDetail.storeCustomDivider(data)
  },
  deleteCustomDivider(context, data) {
    return scoreAssDetail.deleteCustomDivider(data)
  },
  findCustomDivider(context, { sc_setup_id, program_structure_id }) {
    return scoreAssDetail.findCustomDivider(sc_setup_id, program_structure_id)
  },
  getComponent(context, { sc_setup_id, program_structure_id }) {
    return scoreAssDetail.getComponent(sc_setup_id, program_structure_id)
  }
}
